import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { RegistrationStore } from '../../../guards/registration-store';

@Component({
  selector: 'app-registration-cancel',
  imports: [],
  templateUrl: './registration-cancel.component.html',
  styleUrl: './registration-cancel.component.scss'
})
export class RegistrationCancelComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly registrationStore = inject(RegistrationStore);
  event = this.route.parent!.snapshot.data['event'];  // added by resolver

  contactEmail: string = environment.contact_email;

  constructor() {
  }

  ngOnInit() {
    this.registrationStore.clear();
  }

}
